import { render, staticRenderFns } from "./PartnersList.vue?vue&type=template&id=176fdae2&"
import script from "./PartnersList.vue?vue&type=script&lang=ts&"
export * from "./PartnersList.vue?vue&type=script&lang=ts&"
import style0 from "./PartnersList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports